import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface KeysFromKeyVaultState {
  keys: {
    GOOGLE_MAPS_API_KEY: string
  }
  isLoading: boolean
  error: string | undefined
}

const initialState: KeysFromKeyVaultState = {
  keys: {
    GOOGLE_MAPS_API_KEY: ''
  },
  isLoading: false,
  error: undefined
}

const keysFromKeyVaultSlice = createSlice({
  name: 'keysFromKeyVault',
  initialState,
  reducers: {
    fetchKeysLoadingAction (state) {
      return { ...state, isLoading: true }
    },
    fetchKeysUpdateAction (state, action: PayloadAction<{ KEY: string, VALUE: string }>) {
      return { ...state, isLoading: false, keys: { ...state.keys, [action.payload.KEY]: action.payload.VALUE } }
    },
    fetchKeysErrorAction (state, action: PayloadAction<string>) {
      state.isLoading = false
      state.error = action.payload
    }
  }
})

export const { fetchKeysLoadingAction, fetchKeysUpdateAction, fetchKeysErrorAction } = keysFromKeyVaultSlice.actions

export default keysFromKeyVaultSlice.reducer
